import React from "react";

function DashboardTopBar({ isFormOpen }) {
  return (
    <header className="w-full bg-white shadow-sm border-b border-gray-200 px-6 py-4 flex items-center justify-between">
      {/* Left: Logo */}
      <div className="flex items-center space-x-2 shrink-0">
        <img src="/image/Vector.png" alt="logo" className="w-8 h-8" />
        <img
          src="/image/FasTrack Logistics.png"
          alt="logo text"
          className="w-24 h-8 object-contain"
        />
      </div>

      {/* Center: Title */}
      <h1 className="text-sm sm:text-base md:text-lg font-semibold text-gray-800 text-center flex-1">
        {isFormOpen ? "Shipment Request Form" : "Dashboard Client"}
      </h1>

      {/* Right: Avatar */}
      <div className="flex items-center justify-end space-x-2 shrink-0">
        <img
          src="/image/Ellipse 1.png"
          alt="User Avatar"
          className="h-8 w-8 rounded-full object-cover"
        />
      </div>
    </header>
  );
}

export default DashboardTopBar;
